// extracted by mini-css-extract-plugin
export var menuIcon = "_tj-0";
export var menuIconInline = "_tj-1";